/* Application wide styles */

/* Used in pricing and documents tabs */

label.confirmComplete {
    padding:10px 10px 0px 20px;
    background-color:#efefef;
    height:45px
}

label.confirmComplete input {
    margin: -5px 0px 0px -10px !important;
}

.dissapearMessage {
    display: none;
}

#statusBar{
    height:22px;
    margin:0px 0px 4px 0px;
    background-color:#fee101;
    position:fixed;top:0px;left:0px;width:100%;
    z-index: 1050;
}

#appTabsHeader {
    position:fixed;
    top:22px;
    padding:4px 0px 0px 0px;
    left:0px;
    width:100%;
    height:110px;
    background-color:#323133;
    color:#ffffff;
    z-index: 1500;    
}

#appTabsContent {
    padding-top:124px;
}


.tabMenuContainer{
	padding-bottom: 25px;	
}

#tabNavigation {
    position: fixed;
    bottom:0px;
    left:0px;
    opacity: 1;
	background-color: #fff;
    width:100%;
    height:38px;
}

#tabNavigation a.btn.btn-default {
    background-color: #000;
    color: #fff;
    font-size:22px;
}

#developmentMode {
    position:fixed;
    bottom:0px;
    left:50%;
    width: 150px;
    margin-left: -75px;
    background-color:red;
    font-size:11px;
    padding:3px;
    color:#ffffff;
    z-index:5000;
    display: none;
    text-align:center;
}

.form-horizontal .control-label
{
    text-align: left !important;
}

div.intl-tel-input {
    width: 100% !important;
}

.generalInformation h3,
.servingInformation h3,
.additionalInformationContainer h3,
.contactInformation h3,
.storeInformation h3,
.itemInformation th h3,
.customItemInformation th h3 {
    width: 100%;
    background-color: black;
    color: white;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 4px;
    text-transform: uppercase;
    font-weight: bold;
}

.itemInformation th,
.customItemInformation th {
    background-color: #FFF
}

.itemInformation th h3,
.customItemInformation th h3,
.pricingHeader {
    display: inline-block;
    margin-right: 3px;
    font-weight: bold;
}

.contactInformation h4 {
    width: 100%;
    color: #333;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 4px;
    text-transform: uppercase;
    font-weight: bold;
}

#mainPage {
    padding-left: 5px;
    padding-right: 5px;
}

.proposalTotal {
	background-color:#ffffff;
	color: #323133;
	padding: 5px;
	border: 1px solid transparent;
	border-radius: 4px
}

.ui-datepicker-trigger {
    float: right;
    height: 34px;
}

.pointer {
    cursor: pointer;
}

.proposalList .checkbox {
    display: table-cell;
}

/* ProposalList */
/*.deleteButton, .loadButton, .selectedProposalLabel {
    margin: 0px 5px;
    float:right;
}*/

th.checkboxTit {
    width: 5%;
}

th.codeTit {
    width: 10%;
}

th.nameTit {
    width: 40%;
}

th.statusTit {
    width: 15%;
}

th.totalATit {
    width: 10%;
}

th.actions {
    width: 20%;
}

input.checkboxProposalList {
    width: 25px;
    margin: 0px !important;
    position: static !important;
}

.noProposals {
    clear: both;
}



// WEBPACK FOOTER //
// ./static/css/proposal-builder.css